import request from 'utils/request'

/**
 * 获取企业列表
 * @param data
 * @returns {*}
 */
export const getCustomerList = data => request().get(`customer/list/${data}`)

// 查询 申请后限额峰值
export const limitSumInTime = data => request().post(`bp/limitSumInTime`, data)

// 获取货币下拉选
export const getMoneyList = () => request().get('exchange/rate/moneyList')

export const getChangeMount = moneyId =>
request().get(`exchange/rate/getChangeMount/${moneyId}`)

/**
 * 查看是否能申请
 * @param {*} data
 */
export const checkAllow = data => request().get(`bp/apply/checkAllow/${data}`)

/**
 * 查询基本详情
 * @param {*} data
 */
export const queryBase = data => request().get(`bp/apply/queryBase/${data}`)

/**
 * 获取业务类型列表
 */
export const getBusinessList = () => request().get('business/list')

/**
 * 获取法人主体列表
 */
export const getLegalList = () => request().get('customer/legal/list')

/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)

export const getSegmentLevelList = data =>
  request().post('sysSegment/segmentLevel/list', data)

/**
 * 获取信用主管审批人列表
 */
export const getManagerList = () => request().get('bp/apply/listCManager')

/**
 * 账期调整审批人列表
 */
export const getManagerTermList = () =>
  request().get('bp/apply/listCManagerTerm')

/**
 * 提交信用申请
 */
export const creditApply = data => request().post('bp/apply', data)

/**
 * 提交自动审核
 */
export const creditApplyAuto = data => request().post('bp/applyAutomatic', data)

/**
 * 撤销申请
 * @param {*} data
 */
export const cancelApply = data => request().get(`bp/apply/cancel/${data}`)

/**
 * 获取批量申请列表
 * @param {*} data
 */
export const getBatchApplyList = data =>
  request().post('bp/batch/upload/page', data)

/**
 * 获取审批人列表
 */
export const getApprovePersons = () =>
  request().get('bp/batch/apply/listApprovePerson')

/**
 * 下载批量申请模板
 */
export const downloadTemp = () =>
  request().get('bp/batch/template/download', { responseType: 'blob' })

/**
 * 上传批量申请文件
 * @param {*} data
 */
export const uploadBatchFile = data =>
  request().post('bp/batch/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const batchCheck = id => request().get(`bp/batch/upload/check/${id}`)

/**
 * 提交批量申请审批
 * @param {*} data
 */
export const batchApply = data => request(false).post('bp/batch/apply', data)

/**
 *
 *获取业务模式
 *
 */
export const getModelList = data => request().post('business/region/list', data)

export const exportApplyList = data =>
  request().post('bp/apply/exportMine', data, {
    responseType: 'arraybuffer',
  })

export const exportList = data =>
  request().post('bp/batch/upload/export', data, {
    responseType: 'arraybuffer',
  })

// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')

//获取Segment冻结列表
export const getFreezeSegmentList = () =>
  request().get('sysSegment/getFreezeSegmentList')

// 获取业务类型冻结列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

/**
 * 获取Segment列表
 */
export const getSegmentList = business =>
  request().post(`sysSegment/group/${business}`)
/**
 * 获取BG下拉列表
 */
export const getBgList = () => request().get('business/list')
//根据business查name
export const selectName = business =>
  request().post(`business/selectName/${business}`)
//根据segment查segmentLevel
export const selectLevel = segment =>
  request().post(`sysSegment/selectLevel/${segment}`)

/**
 * 查看是否能申请
 * @param {*} data
 */
export const checkCom = data => request().get(`bp/apply/checkCom/${data}`)
// 获取公司账期
export const searchTerm = code => request().post(`customer/termList/${code}`)
// 获取母公司Id
export const getParentList = data => request().get(`customer/list/${data}`)
// 公司账期提交
export const addGroup = data => request().post('period/addPeriod', data)
/**
 * 获取申请页详情
 */
export const getAmountDetail = data =>
  request().post('limit/approve/limit', data)
// 限额延期申请
export const addLimit = data => request().post('limit/addLimit', data)
/**
 * 查询公司基本详情
 */
export const selectCompany = data =>
  request().get(`period/apply/selectCompany/${data}`)
/**
 * 获取专项申请页详情
 */
export const getSpecialDetail = data =>
  request().post('limit/approve/special', data)
// 专项额度延期申请
export const addSpecial = data => request().post('limit/addSpecial', data)
// 获取专项额度最大时间
export const selectSpecialTime = code =>
  request().get(`limit/selectSpecialTime/${code}`)
/**
 * 下载项额度批量申请模板
 */
export const limitDownload = () =>
  request().get('limit/download', { responseType: 'blob' })
/**
 * 上传批量申请文件 获取上传code的相关信息
 * @param {*} data
 */
export const uploadCodeFile = data =>
  request().post('limit/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'blob',
  })
/**
 * 上传批量申请文件
 * @param {*} data
 */
export const uploadLimitFile = data =>
  request().post('limit/limitUpload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
/**
 * 获取批量申请列表
 * @param {*} data
 */
export const getLimitBatchList = data =>
  request().post('limit/batch/upload/page', data)
/**
 * 限额延期批量申请验证
 */
export const check = id => request().get(`limit/batch/upload/check/${id}`)
/**
 * 提交批量申请审批
 * @param {*} data
 */
export const batchLimit = data => request(false).post('limit/batch/apply', data)

/**
 * 查询自动审批设置条件
 */
export const getAutomaticRequired = () =>
  request().get('oneselfExamine/getAutomaticRequired')

/**
 * 撤销申请
 * @param {*} data
 */
export const cancelExtension = data =>
  request().get(`limit/apply/cancel/${data}`)

/**
 * 获取审批人列表
 */
export const getLimitApprovePersons = id =>
  request().get(`limit/batch/apply/listApprovePerson/${id}`)

export const exportExtensionList = data =>
  request().post('limit/apply/exportMine', data, {
    responseType: 'arraybuffer',
  })

export const exportLists = data =>
  request().post('limit/batch/upload/export', data, {
    responseType: 'arraybuffer',
  })

  // 获取标准账期
export const getPeriodist = data => request().post('accountPeriod/periodList', data)


  // 获取标准账期
export const getPeriodists = data => request().post('accountPeriod/periodLists', data)